import "@/App.css";
import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "./pages/Home";
import CustomCursor from "./components/CustomCursor";
import PreLoader from "./components/PreLoader";
import { LanguageProvider } from "./i18n/LanguageContext";

function App() {
  const [loading, setLoading] = useState(true);

  return (
    <div className="App">
      <LanguageProvider>
        {loading && <PreLoader onDone={() => setLoading(false)} />}
        <CustomCursor />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "rgba(20,20,20,0.92)",
              border: "1px solid rgba(255,255,255,0.08)",
              color: "#f5f5f5",
              fontFamily: "'IBM Plex Sans', sans-serif",
            },
          }}
        />
      </LanguageProvider>
    </div>
  );
}

export default App;
